<template>
  <v-app>
    <v-main>
      <v-container class="content fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6">
            <div class="title">Jogo da Velha</div>

            <v-card class="custom-card" elevation="0">
              <v-card-title class="headline">
                <v-chip outlined>Jogador: {{ currentPlayer }}</v-chip>
                <v-spacer></v-spacer>
                <v-chip class="mr-2" outlined>Placar X: {{ score.X }}</v-chip>
                <v-chip outlined>Placar O: {{ score.O }}</v-chip>
              </v-card-title>

              <v-card-text class="mt-4">
                <div class="board">
                  <div
                    v-for="(cell, idx) in board"
                    :key="idx"
                    class="cell"
                    :class="{
                      winning: winningLine && winningLine.includes(idx),
                    }"
                    @click="play(idx)"
                  >
                    <div
                      class="cell-btn"
                      depressed
                      block
                      :disabled="!!cell || !!winner"
                    >
                      <span class="cell-symbol">{{ cell }}</span>
                    </div>
                  </div>
                </div>

                <div class="mt-4 text-center">
                  <v-alert v-if="winner" type="success" dense>
                    {{ winnerMessage }}
                  </v-alert>

                  <v-alert v-else-if="isDraw" type="info" dense>
                    Empate!
                  </v-alert>
                </div>
              </v-card-text>

              <div class="d-flex justify-center align-center pa-4">
                <v-btn
                  class="button mx-2"
                  color="#c97c7c"
                  depressed
                  @click="resetGame"
                >
                  Reiniciar jogo
                </v-btn>
                <v-btn
                  class="button mx-2"
                  color="#bd9f9f"
                  depressed
                  @click="resetScore"
                >
                  Zerar placar
                </v-btn>
              </div>
            </v-card>
            <div class="mt-3 text-center caption">JCSystem</div>
            <div class="mt-2 text-center caption">
              Feito com Vue.js 2 + Vuetify
            </div>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="300">
          <v-card class="text-center pa-4">
            <!-- Imagem de vitória ou derrota -->
            <v-img
              v-if="winner && winner !== 'draw'"
              :src="require('@/assets/win.png')"
              max-width="100"
              class="mx-auto mt-6"
            ></v-img>

            <v-img
              v-if="winner && winner === 'draw'"
              :src="require('@/assets/game-over.png')"
              max-width="100"
              class="mx-auto mt-6"
            ></v-img>

            <v-card-title class="headline justify-center">
              {{ winnerMessage }}
            </v-card-title>
            <v-card-title class="headline justify-center">
              Jogar novamente?
            </v-card-title>

            <v-card-actions class="justify-center">
              <v-btn text @click="dialog = false">Não</v-btn>
              <v-btn color="primary" @click="confirmRestart">Sim</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "TicTacToe",
  data() {
    return {
      board: Array(9).fill(null),
      currentPlayer: "X",
      winner: null,
      winningLine: null,
      dialog: false,
      score: { X: 0, O: 0 },
    };
  },
  computed: {
    isDraw() {
      return !this.winner && this.board.every((c) => c !== null);
    },
    winnerMessage() {
      return this.winner === "draw" ? "Empate!" : `${this.winner} venceu!`;
    },
  },
  methods: {
    play(idx) {
      if (this.board[idx] || this.winner) return;
      this.$set(this.board, idx, this.currentPlayer);

      const result = this.checkWinner(this.board);
      if (result) {
        this.winner = result.player;
        this.winningLine = result.line;
        if (this.winner !== "draw") {
          this.score[this.winner] += 1;
        }
        setTimeout(() => (this.dialog = true), 300);
        return;
      }

      this.currentPlayer = this.currentPlayer === "X" ? "O" : "X";
    },
    checkWinner(b) {
      const lines = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6],
      ];

      for (let line of lines) {
        const [a, c, d] = line;
        if (b[a] && b[a] === b[c] && b[a] === b[d]) {
          return { player: b[a], line };
        }
      }

      if (b.every((x) => x !== null)) return { player: "draw", line: null };
      return null;
    },
    resetGame() {
      this.board = Array(9).fill(null);
      this.currentPlayer = "X";
      this.winner = null;
      this.winningLine = null;
      this.dialog = false;
    },
    confirmRestart() {
      this.resetGame();
      this.dialog = false;
    },
    resetScore() {
      this.score = { X: 0, O: 0 };
      this.resetGame();
    },
  },
};
</script>

<style scoped>
.button {
  text-transform: none;
  color: white !important;
}

.title {
  font-size: 2.5rem !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #c97c7c;

  display: flex;
  justify-content: center;
  align-items: center;

  text-shadow: 1px 1px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000,
    -2px -2px 0 #000;
}

.content {
  background-color: #f3c53e;
}

.caption {
  font-size: 0.75rem !important;
  font-weight: bold;
  text-align: center;
  color: #4e2323;
}

.custom-card {
  background-color: #fff3e0;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.board {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8px;
  max-width: 400px;
  margin: 0 auto;
}

.cell {
  position: relative;
  width: 100%;
  padding-top: 100%;
}

.cell-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: bold;
  background-color: rgb(201, 124, 124);
}

.winning {
  background-color: rgba(76, 175, 80, 0.15);
}
</style>
